import React from "react";
import { Container, Row, Col, Image, Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "./about.css";
const About = () => (
  <section id="about" className="py-5">
    <Helmet>
      <title>Putha P L Narasimha Rao | Full Stack Developer</title>
        <meta
  property="og:image"
  content="https://puthaplnrao.co.in/narasimha_safari_sute.png"
/>

<meta
  name="twitter:image"
  content="https://puthaplnrao.co.in/narasimha_safari_sute.png"
/>
      <meta
        name="description"
        content="Portfolio of Putha P L Narasimha Rao (P L Narasimha Putha, puthaplnrao, P L Narasimha Rao Putha, P P L Narasimha Rao) – Full Stack Developer specializing in React, Node.js, MongoDB, and scalable systems."
      />
      <meta
        name="keywords"
        content="Narasimha Putha, puthaplnrao, Putha P L Narasimha Rao, P L Narasimha Rao Putha, P P L Narasimha Rao, Full Stack Developer, React Developer, Node.js Developer, MongoDB, MERN Developer, OTT, Video Streaming"
      />
      <link rel="canonical" href="https://puthaplnrao.co.in/" />

      {/* Open Graph */}
      <meta
        property="og:title"
        content="Putha P L Narasimha Rao | Full Stack Developer"
      />
      <meta
        property="og:description"
        content="Explore the portfolio of Putha P L Narasimha Rao – React, Node.js, MongoDB, OTT platforms, scalable backend systems."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://puthaplnrao.co.in/" />
      <meta property="og:image" content="https://puthaplnrao.co.in/narasimha_safari_sute.png" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Putha P L Narasimha Rao | Full Stack Developer"
      />
      <meta
        name="twitter:description"
        content="React, Node.js, MongoDB, OTT platforms, REST APIs, scalable backend systems."
      />
      <meta name="twitter:image" content="https://puthaplnrao.co.in/narasimha_safari_sute.png" />
    </Helmet>

      <Container fluid className="px-4 px-xl-5">
      <Row className="align-items-center">
        <Col md={4} className="text-center mb-0 mb-md-0">
          <Image
            src="narasimha_safari_sute.png"
            alt="Putha P L Narasimha Rao | Narasimha Putha | puthaplnrao"
            roundedCircle
            fluid
            // className="shadow-lg"
          />
        </Col>
        <Col md={8}>
          <Card className="border-0 shadow-sm graycard">
            <Card.Body>
              {/* Main SEO Heading */}
              <h1 className="fw-bold mb-3">
                Putha P L Narasimha Rao{" "}
                {/* <small>(Narasimha Putha / puthaplnrao)</small> */}
              </h1>

              <p>
                I’m an experienced Full Stack Developer and Technical Lead with 10+ years in software development, specializing in
                building scalable RESTful APIs, backend systems, and modern
                frontend applications.
              </p>

              <ul className="ps-3">
                <li>
                  Expert in Node.js, Express.js, PHP, React.js, and REST APIs
                </li>
                <li>
                  Developed AI-powered tools, OTT platforms, billing &
                  subscription systems
                </li>
                <li>
                  Hands-on with video streaming (FFmpeg, HLS, AES encryption)
                  and AWS S3
                </li>
                <li>
                  Worked with MySQL, MongoDB, RabbitMQ, Memcache, Docker, GitHub
                  Actions
                </li>
                <li>
                  Led projects with end-to-end architecture, deployment, and
                  CI/CD pipelines
                </li>
              </ul>

              <p>
                I am passionate about
                building efficient, scalable applications and mentoring teams
                toward success through clean architecture and modern tooling.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  </section>
);

export default About;
